import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Container } from "reactstrap";

import BreadCrumb from "../../Components/Common/BreadCrumb";

import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";

import Loading from "../../Components/Loading/Loading";
import PlaceDetails from "../../Components/Places/PlaceDetails";
import { getCityRequest } from "../../store/city/actions";
import InfoCity from "./components/InfoCity";

const CityList = () => {
  document.title = "Cidades | Ecoguias - Admin Dashboard";

  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const { data, loading } = useSelector((state) => state.City);

  useEffect(() => {
    dispatch(getCityRequest(id));
  }, [id, dispatch, history]);

  function renderPlaceDetails() {
    if (!data?.result) {
      return null;
    }

    return (
      <PlaceDetails
        loading={loading}
        data={data?.result?.city}
        images={data?.result?.images}
        pathPaginationName="/stores"
        menu={<InfoCity data={data?.result?.city} />}
      />
    );
  }

  return (
    <React.Fragment>
      <ToastContainer />

      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Cidade" pageTitle="Locais" />
        </Container>

        {loading ? (
          <Loading />
        ) : (
          <>
            <div className="p-4">
              <button
                className="btn btn-primary"
                onClick={() => history.goBack()}
              >
                Voltar
              </button>
            </div>

            {renderPlaceDetails()}
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default CityList;
